require('normalize.css/normalize.css');
require('styles/App.scss');

import React from 'react';

class DisplayError extends React.Component {
  render() {
    return <h2>{this.props.msg}</h2>
  }
}

class DisplayResults extends React.Component {
  render() {
    if (this.props.typ == '3') {
      return(
      <DisplayZivResults mzda={this.props.mzda} typ={this.props.typ}/>
      )
    } else {
      return(
      <DisplayZamResults mzda={this.props.mzda} typ={this.props.typ}/>
      )
    }
  }
}

class DisplayZivResults extends React.Component {
  render() {
    var sleva = 24840/12;
    var amount = this.props.mzda;
    var dnes_soc = Math.round(amount*0.146*-1);
    if (dnes_soc >= -1972) {
      dnes_soc=-1972
    }
    var dnes_zdrav = -1823; //Math.round(amount*0.045*-1);
    var dnes_dpfo = Math.round((amount*0.15-sleva)*-1);
    if (dnes_dpfo > 0) {
      dnes_dpfo = 0
    }
    var dnes_total = Math.round(+amount+dnes_zdrav+dnes_soc+dnes_dpfo);
    var svob_komb = Math.round((amount*0.296-3070)*-1);
    if (svob_komb >= -972) {
      svob_komb=-972
    }
    var svob_total = Math.round(+amount+dnes_zdrav+svob_komb);
    var svob_win = Math.round(svob_total - dnes_total);
    return(
    <div>
      <h2>DNES</h2>
      <table className="table table-striped">
        <tbody>
          <tr><th>zisk (příjmy minus výdaje)</th><td>{amount} Kč</td></tr>
          <tr><th>zdravotní pojištění</th><td>{dnes_zdrav} Kč</td></tr>
          <tr><th>pojistné sociální</th><td>{dnes_soc} Kč</td></tr>
          <tr><th>daň z příjmu</th><td>{dnes_dpfo} Kč</td></tr>
          <tr><th>čistý příjem</th><td>{dnes_total} Kč</td></tr>
        </tbody>
      </table>
      <h2>Se Svobodnými</h2>
      <table className="table table-striped">
        <tbody>
          <tr><th>zisk (příjmy minus výdaje)</th><td>{amount} Kč</td></tr>
          <tr><th>zdravotní pojištění</th><td>{dnes_zdrav} Kč</td></tr>
          <tr><th>kombinovaný odvod (29,6 % -velká sleva 3070)</th><td>{svob_komb} Kč</td></tr>
          <tr><th>čistý příjem</th><td>{svob_total} Kč</td></tr>
        </tbody>
      </table>
      <h2>Se Svobodnými vyděláte {svob_win} Kč</h2>
    </div>)
  }
}

class DisplayZamResults extends React.Component {
  render() {
    var dite = 0;
    var dite_text = '';
    var amount = this.props.mzda;
    if (this.props.typ == '1') {
      dite = 1117;
      dite_text = ' - zvýhodnění na dítě 1117 Kč';
    }
    if (this.props.typ == '2') {
      dite = 2534;
      dite_text = ' - zvýhodnění na děti 2534 Kč';
    }
    var dnes_soc = Math.round(amount*0.065*-1);
    var dnes_zdrav = Math.round(amount*0.045*-1);
    var dnes_dpfo = Math.round((amount*1.34*0.15-2070-dite)*-1);
    var dnes_total = Math.round(+amount+dnes_zdrav+dnes_soc+dnes_dpfo);
    var svob_komb = Math.round((amount*0.266-3070-dite)*-1);
    var svob_total = Math.round(+amount+dnes_zdrav+svob_komb);
    var svob_win = Math.round(svob_total - dnes_total);
    return(
    <div>
      <h2>DNES</h2>
      <table className="table table-striped">
        <tbody>
          <tr><th>hrubá mzda</th><td>{amount} Kč</td></tr>
          <tr><th>sociální zaměstnance (6,5 % hrubé mzdy)</th><td>{dnes_soc} Kč</td></tr>
          <tr><th>zdravotní zaměstnance (4,5 % hrubé mzdy)</th><td>{dnes_zdrav} Kč</td></tr>
          <tr><th>DPFO (15 % ze 135 % hrubé mzdy - sleva 2070 Kč{dite_text})</th><td>{dnes_dpfo} Kč</td></tr>
          <tr><th>čistá mzda</th><td>{dnes_total} Kč</td></tr>
        </tbody>
      </table>
      <h2>Se Svobodnými</h2>
      <table className="table table-striped">
        <tbody>
          <tr><th>hrubá mzda</th><td>{amount} Kč</td></tr>
          <tr><th>zdravotní zaměstnance (4,5 % hrubé mzdy)</th><td>{dnes_zdrav} Kč</td></tr>
          <tr><th>kombinovaný odvod (26,6 % hrubé mzdy - velká sleva 3070 Kč{dite_text})</th><td>{svob_komb} Kč</td></tr>
          <tr><th>čistá mzda</th><td>{svob_total} Kč</td></tr>
        </tbody>
      </table>
      <h2>Se Svobodnými vyděláte {svob_win} Kč</h2>
    </div>)
  }
}

class MzdaForm extends React.Component {

  constructor(props) {
    super(props);
    this.state = {mzda: 20000, typ: 0};
    this.handleChange = this.handleChange.bind(this);
    // this.handleClick = this.handleClick.bind(this);
  }

  handleChange(event) {
    var error = '';
    if (event.target.value=='') {
    } else if (Number(parseFloat(event.target.value))!=event.target.value) {
      error = 'Chyba: '+event.target.value+' není číslo'
    } else if (Number(parseFloat(event.target.value))<12000) {
      error = 'Zadejte hrubou mzdu v intervalu 12 000 až 100 000 Kč'
    } else if (Number(parseFloat(event.target.value))>100000) {
      error = 'Zadejte hrubou mzdu v intervalu 12 000 až 100 000 Kč'
    } else {
      error = false
    }
    this.setState({mzda: event.target.value, error})
  }

  handleClick(index) {
    this.setState({typ: index})
  }

  render() {
    return (
      <div>
      <form className="mzda">
        <h2>Vaše hrubá mzda:</h2>
        <div className="row">
          <div className="col-sm-4">
            <input type="text" className="mzda" size="5" value={this.state.mzda} onChange={this.handleChange} />
          </div>
          <div className="col-sm-6">
            <div onClick={this.handleClick.bind(this,0)}><input type="radio" checked={this.state.typ === 0} value="0" /> Daňový poplatník - jednotlivec</div>
            <div onClick={this.handleClick.bind(this,1)}><input type="radio" checked={this.state.typ === 1} value="1" /> Daňový poplatník - jedno dítě</div>
            <div onClick={this.handleClick.bind(this,2)}><input type="radio" checked={this.state.typ === 2} value="2" /> Daňový poplatník - dvě děti</div>
            <div onClick={this.handleClick.bind(this,3)}><input type="radio" checked={this.state.typ === 3} value="3" /> Živnostník - bez dětí</div>
          </div>
        </div>
        {this.state.error ? <DisplayError msg={this.state.error}/> : <DisplayResults mzda={this.state.mzda} typ={this.state.typ}/> }
      </form>

      </div>
    );
  }
}

class AppComponent extends React.Component {
  render() {
    let imglogo = require('../images/SVOBODNI-logo-tagline-POZITIV.png');
    let imgtisicovka = require('../images/tisicovka-web.png');
    require('../images/tisicovka-fb.png');
    let pdfko = require('../images/tiskovka-tisicovka.pdf');

    return (
      <div className="content">
        <div className="row">
          <div className="col-sm-12">
            <img src={imgtisicovka} />

            <h1>Plus tisícovka měsíčně pro&nbsp;každého</h1>
            <p className="perex">Svobodní mají plán, jak snížit všem pracujícím daně a odvody tak, aby každému zůstalo o 1000 korun čistého měsíčně navíc. Zrušíme nespravedlivé dotace pro firmy, proto budeme moci snížit daně lidem.</p>
            <hr />
            <div className="videowrapper">
              <iframe width="560" height="315" src="https://www.youtube.com/embed/5F87usjmpjo" frameborder="0" allowfullscreen></iframe>
            </div>
            <hr />
            <h1>Kalkulačka</h1>
            <MzdaForm/>
            <hr />

            <h1>Kde lze ušetřit?</h1>
            <p className="perex">Svobodní nechají více peněz v kapsách lidí, protože ukončí nespravedlivé dotování podniků.</p>
            <p className="perex">Zrušíme státní podporu biopaliv, dotace na solární elektrárny, investiční a filmové pobídky, podporu exportu a dotace podnikatelům.</p>
            <p className="perex">Stát podle Svobodných nemá přerozdělovat peníze z kapes lidí do kapes firem. </p>
            <p className="perex">Zrušíme také zbytečné úřady jako Czechtrade, CzechInvest, úřad Zmocněnce vlády pro lidská práva, Radu vlády pro rovnost mužů a žen, apod. aby peníze mohly zůstat v kapsách lidí.</p>
          </div>
        </div>
        <a href={pdfko} className="btn btn-primary btn-block">&gt;&gt;&nbsp;Stáhněte si PDF&nbsp;&lt;&lt;</a>
        <div className="row">
          <div className="col-md-2"></div>
          <div className="col-md-8 offset-md-4"><img className="logo" src={imglogo} /></div>
        </div>
      </div>
    );
  }
}

AppComponent.defaultProps = {
};

export default AppComponent;



// WEBPACK FOOTER //
// ./src/components/Main.js